import {Pipe, PipeTransform, Injectable} from '@angular/core';
@Pipe({
    name: 'statusFilter'
})
@Injectable()
export class StatusFilterPipe implements PipeTransform {
    transform(items: any, field: string, value: string): any {
       
        switch (items) {
            case  'Completed with Passed':
                return 'Passed';
            case 'Completed with Failed':
                return 'Did not pass';
            case  'Completed':
                return 'Passed';    
            default:
                return items;
        }
    }
}
